import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../common/store/types';
import { ClaimTypeModel } from './types';
import { claimTypeActions } from './claim-type.actions';

export interface IClaimTypeState extends IState<ClaimTypeModel> {
  getById: GenericState<ClaimTypeModel>;
  createInstance: GenericState<ClaimTypeModel>;
  add: GenericState<ClaimTypeModel>;
  update: GenericState<ClaimTypeModel>;
  delete: GenericState<boolean>;
}

export const claimTypeInitialState: IClaimTypeState = {
  getById: new GenericState<ClaimTypeModel>(),
  createInstance: new GenericState<ClaimTypeModel>(),
  add: new GenericState<ClaimTypeModel>(),
  update: new GenericState<ClaimTypeModel>(),
  delete: new GenericState<boolean>(),
};

const claimTypeReducers = [
  ...onApiCall<ClaimTypeModel>(claimTypeActions.getById, 'getById'),
  ...onApiCall<ClaimTypeModel>(
    claimTypeActions.createInstance,
    'createInstance',
  ),
  ...onApiCall<ClaimTypeModel>(claimTypeActions.add, 'add'),
  ...onApiCall<ClaimTypeModel>(claimTypeActions.update, 'update'),
  ...onApiCall<boolean>(claimTypeActions.delete, 'delete'),
];

export const claimTypeReducer = createReducer(
  claimTypeInitialState,
  ...claimTypeReducers,
) as ActionReducer<IClaimTypeState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return claimTypeReducer(state, action);
}
